module.exports = __webpack_public_path__ + "img/pr-1.44409e74.png";